import React, { Fragment, useState, useEffect } from 'react'
import { withRouter, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import estilos from './SolicitudComponent.module.css'
import { renderSolicitud, renderTipoSolicitud } from '../InspectorUtils/InspectorUtils'

import NoteAltIcon from '@mui/icons-material/NoteAlt';
import { getInstalacionesByCliente } from '../../../redux/DucksUnidadInspeccion/AsociadosDuck';
import { obtenerClienteConDetalleByNumeroSocio } from '../../../redux/DucksAtencionACliente/ModuloConsultaDucks'
import { getAllInformes, insertInforme } from '../../../redux/DucksUnidadInspeccion/InformeCumplimientoDuck';
import { updateSolicitud } from '../../../redux/DucksUnidadInspeccion/SolicitudesUIF01Duck';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import esLocale from "date-fns/locale/es";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import InstalacionComponent from './InstalacionComponent'

import { getClienteByNumsocio } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { actualizarInforme } from '../../../redux/DucksUnidadInspeccion/ArchivosDuck';

import moment from 'moment'
import 'moment/locale/es'
import { CheckCircle, DoneAll, Upload, Visibility } from '@mui/icons-material'
import { Store } from 'react-notifications-component'

function SolicitudComponent(props) {
    const tipo = props.tipo; const status = props.status; const user = props.user; const solicitud = props.solicitud; const index = props.index;
    const [numeroSocio, setNumeroSocio] = React.useState(0);
    const instalaciones = useSelector(store => store.Asociado.instalaciones);
    const history = useHistory();
    const dispatch = useDispatch()

    //const [instalacionesDelClienteSeleccionado,setInstalacionesDelClienteSeleccionado] = useState({});
    const cliente = useSelector(store => store.ModuloConsulta.cliente)

    const [openModalSeleccionarInstalacion, setOpenModalSeleccionarInstalacion] = React.useState(false);

    const handleOpenModalSeleccionarInstalacion = async (numerosocio) => {
        setOpenModalSeleccionarInstalacion(true)
        setNumeroSocio(numerosocio)
    }

    useEffect(async () => {
        if (numeroSocio != 0) {
            dispatch(obtenerClienteConDetalleByNumeroSocio(numeroSocio)).then((response) => {
                dispatch(getInstalacionesByCliente(response.payload.idcliente))
            })
        }
    }, [openModalSeleccionarInstalacion, numeroSocio]);



    const handleCloseModalSeleccionarInstalacion = () => {
        setOpenModalSeleccionarInstalacion(false);
        setNumeroSocio(0)
    }


    const style = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 1000, height: 600,
        bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24, p: 4
    };


    const handleSetCliente = (instalacion, idclienteSeleccionado, idinformaciongeneralcliente, alias) => {
        // const data = {
        //     data: {
        //         idiformaciongeneralcliente: idinformaciongeneralcliente,
        //         idcliente: idclienteSeleccionado,
        //         idfc01_solicitudregistro: solicitud.idfc01_solicitudregistro
        //     }
        // }

        //dispatch(insertInforme(data))   //agregar informe

        //props.history.push("/PanelInspeccion", {
        //    state: {
        //        idclienteSeleccionado,
        //        instalacion,
        //        alias,
        //        optionTab: 1,
        //        ncomision: solicitud.ncomision,
        //        folioui: solicitud.folioui
        //    }
        //});
        //console.log(solicitud)
        history.push("/PanelInspeccion", {
            state: {
                idclienteSeleccionado,
                instalacion,
                alias,
                optionTab: 1,
                solicitud: solicitud,
                ncomision: solicitud.ncomision,
                folioui: solicitud.folioui
            }
        });
    }


    const dictaminarSolicitud = () => {
        const dataSolicitud = {
            data: {
                idsolicitudesuifc01: solicitud.idsolicitudesuifc01,
                idinspector: solicitud.idinspector,
                fecharealdeinspeccion: solicitud.fecharealdeinspeccion,
                asignadopor: solicitud.asignadopor,
                statusdelasolicitud: 2,
                folioui: solicitud.folioui,
                ncomision: solicitud.ncomision
            }
        }

        dispatch(updateSolicitud(dataSolicitud)).then((res) => {
            props.actualizarSolicitudes()
            handleCloseConfirmarDictaminar()
            Store.addNotification({
                title: "Informacion guardada correctamente!",
                message: "Guardado Correctamente",
                type: "success",
                insert: "top",
                container: "top-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true
                }
            });
        })
    }

    const modalSeleccionarInstalacion = () => {
        return (
            <Modal
                open={openModalSeleccionarInstalacion}
                onClose={handleCloseModalSeleccionarInstalacion}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Selecciona la instalación {JSON.stringify(cliente?.nombrerazonsocial)}
                    </Typography>
                    <div className='row' style={{ overflow: "scroll", height: 500 }}>
                        {
                            instalaciones?.map((i, index) => (
                                <div key={index}>
                                    {
                                        i.idtipoanexo === 1 ? (
                                            <InstalacionComponent handleSetCliente={handleSetCliente} instalacion={i} nombre={"Unidad de Producción"}></InstalacionComponent>
                                        ) :
                                            i.idtipoanexo === 2 ? (
                                                <InstalacionComponent handleSetCliente={handleSetCliente} instalacion={i} nombre={"Unidad de Envasado"}></InstalacionComponent>
                                            ) :
                                                i.idtipoanexo === 3 ? (
                                                    <InstalacionComponent handleSetCliente={handleSetCliente} instalacion={i} nombre={"Unidad de Almacén"}></InstalacionComponent>
                                                ) :
                                                    <></>
                                    }
                                </div>

                            ))
                        }
                    </div>

                </Box>
            </Modal>
        )
    }

    const styleSubir = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 500,
        bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24, p: 4,
    };

    const [openSubirInforme, setOpenSubirInforme] = React.useState(false);
    const [informeSeleccionado, setInformeSeleccionado] = React.useState(null);

    const handleOpenSubirInforme = () => {
        setOpenSubirInforme(true)
    }

    const handleCloseSubirInforme = () => {
        setOpenSubirInforme(false)
    }

    const handleSetInforme = (e) => {
        setInformeSeleccionado(e.target.files[0])
    }

    const subirNuevoInforme = () => {
        if (informeSeleccionado != null) {
            console.log(solicitud)
            dispatch(getClienteByNumsocio(solicitud.fc_01_solicitudderegistro.numerosocio)).then(async (a) => {
                const data = {
                    informe: informeSeleccionado,
                    idsolicitudesuifc01: solicitud.idsolicitudesuifc01,
                    idcliente: a.payload.data.data.idcliente
                }
                dispatch(actualizarInforme(data));
                handleCloseSubirInforme()
                Store.addNotification({
                    title: "Informacion guardada correctamente!",
                    message: "Guardado Correctamente",
                    type: "success",
                    insert: "top",
                    container: "top-center",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            })
        } else {
            alert("no se selecciono informe")
        }
    }

    const modalSubirInforme = () => {
        return (
            <Modal
                open={openSubirInforme}
                onClose={handleCloseSubirInforme}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleSubir}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Selecciona el Informe
                        <h6 style={{ color: 'red' }}>*Subir el informe firmado en formato pdf</h6>
                    </Typography>
                    <div className='row' style={{ textAlign: "center" }}>
                        <div class="mb-3">
                            <input class="form-control" type="file" id="formFile" accept=".pdf" onChange={(e) => { handleSetInforme(e) }} />
                        </div>
                        <div class="mb-3">
                            <button className='btn btn-success' onClick={subirNuevoInforme}>GUARDAR</button>
                        </div>
                    </div>

                </Box>
            </Modal>
        )
    }

    const styleBox = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const styleBoxObservaciones = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const [openDictaminar, setOpenDictaminar] = React.useState(false);

    const handleOpenConfirmarDictaminar = () => {
        setOpenDictaminar(true)
    };
    const handleCloseConfirmarDictaminar = () => setOpenDictaminar(false);

    const modalConfirmarDictaminar = () => {
        return (
            <Modal
                open={openDictaminar}
                onClose={handleCloseConfirmarDictaminar}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleBox}>
                    <div className='text-center'>
                        ¿Desea realmente finalizar esta solicitud?<br /><br />
                        <button className='btn btn-danger' onClick={() => dictaminarSolicitud()}> Confirmar</button>
                    </div>
                </Box>
            </Modal>
        )
    }

    const [openObservaciones, setOpenObservaciones] = React.useState(false);
    const [observacion, setObservacion] = useState(solicitud.observaciones == null ? '' : solicitud.observaciones);

    const handleOpenObservaciones = () => {
        setOpenObservaciones(true)
    };
    const handleCloseObservaciones = () => setOpenObservaciones(false);

    const handleTextAreaChange = (event) => {
        setObservacion(event.target.value);
    };

    const agregarObservacion = () => {
        const data = {
            data: {
                idsolicitudesuifc01: solicitud.idsolicitudesuifc01,
                observaciones: observacion
            }
        }
        dispatch(updateSolicitud(data)).then((res) => {
            props.actualizarSolicitudes()
            Store.addNotification({
                title: "Informacion guardada correctamente!",
                message: "Guardado Correctamente",
                type: "success",
                insert: "top",
                container: "top-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true
                }
            });
        })
        handleCloseObservaciones()
    };

    const modalAgregarObservaciones = () => {
        return (
            <Modal
                open={openObservaciones}
                onClose={handleCloseObservaciones}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleBoxObservaciones}>
                    <div className='text-center'>
                        <h3>Observaciones de la Actividad</h3>
                        <br />
                        <textarea className="form-control" id="observaciones" rows="3" value={observacion} onChange={handleTextAreaChange}></textarea>
                        <br />
                        <button className='btn btn-success' onClick={agregarObservacion}> Agregar Observación</button>
                    </div>
                </Box>
            </Modal>
        )
    }

    return (
        <Fragment>
            <div className={renderSolicitud(tipo)} key={index}>
                <div className="card-header" style={props.statusui === 2 ? { backgroundColor: "#ADF68E" } : {}}>
                    <p style={{ fontSize: '20px', fontWeight: 'bold' }}> Solicitud ID: {solicitud.fc_01_solicitudderegistro.idfc01_solicitudregistro} | {solicitud.fc_01_solicitudderegistro.folio} | {solicitud.fc_01_solicitudderegistro.informacionmodalaceptada != null ? solicitud.fc_01_solicitudderegistro.informacionmodalaceptada.numerosolicitudservicios : ""}</p>
                </div>
                <div className='card-body' style={props.statusui === 2 ? { backgroundColor: "#DEFFCF" } : {}}>
                    <div className='row'>
                        <div className='col-6'>
                            <p style={{ fontSize: '20px', fontWeight: 'bold', textDecoration: 'underline' }}>{renderTipoSolicitud(solicitud.fc_01_solicitudderegistro.idestatusdesolicitudes)}</p>
                            <p style={{ fontSize: '20px' }}>( {solicitud.fc_01_solicitudderegistro.numerosocio}) : {solicitud.fc_01_solicitudderegistro.nombrerazonsocial} <br /></p>
                            <strong>
                                {solicitud.fc_01_solicitudderegistro.viverista ? ' | Viverista' : null}
                                {solicitud.fc_01_solicitudderegistro.productormaguey ? ' | Productor de Maguey' : null}
                                {solicitud.fc_01_solicitudderegistro.productormezcal ? ' | Productor de Mezcal' : null}
                                {solicitud.fc_01_solicitudderegistro.envasador ? ' | Envasador' : null}
                                {solicitud.fc_01_solicitudderegistro.comercializadormezcal ? ' | Comercializador de Mezcal' : null}
                                {solicitud.fc_01_solicitudderegistro.comercializadorbebidasconmezcal ? ' | Comercializador de Bebidas con Mezcal' : null}
                            </strong>
                            <p style={{ fontSize: '15px', fontWeight: 'bold' }}><br />
                                Estimada para: <strong style={{ fontSize: '15px' }}>{moment.utc(solicitud.fc_01_solicitudderegistro.informacionmodalaceptada != null ? solicitud.fc_01_solicitudderegistro.informacionmodalaceptada.fechainspeccion : solicitud.fc_01_solicitudderegistro.fechasolicitud).format("LL")}</strong></p>
                        </div>
                        <div className='col-4'>

                        </div>

                        <div className='col-2'>
                            {/** i.informaciongeneralinstalacioncliente.instalacionnumero, i.idcliente, i.informaciongeneralinstalacioncliente.idiformaciongeneralcliente, i */}
                            {
                                props.statusui == 1 ?
                                    <Fragment>
                                        <button onClick={() => handleOpenModalSeleccionarInstalacion(solicitud.fc_01_solicitudderegistro.numerosocio)} style={{ marginBottom: '3%', width: '70%' }} className='btn btn-success'><NoteAltIcon />Dictaminar</button><br />
                                        <button onClick={() => handleOpenConfirmarDictaminar()} style={{ marginBottom: '3%', width: '70%' }} className='btn btn-warning'><CheckCircle />Finalizar</button><br />
                                    </Fragment>
                                    :
                                    props.statusui == 2 && props.offline == false ?
                                        <Fragment>
                                            <button onClick={() => handleOpenSubirInforme()} style={{ marginBottom: '3%', width: '70%' }} className='btn btn-success'><NoteAltIcon />Actualizar Informe</button><br />
                                            <button onClick={() => handleOpenObservaciones()} style={{ marginBottom: '3%', width: '70%' }} className='btn btn-warning'><Visibility />Observaciones</button><br />
                                        </Fragment>
                                        :
                                        <Fragment>
                                            <button style={{ marginBottom: '3%', width: '70%' }} className='btn btn-danger'><Upload />Subir Al Servidor</button><br />
                                        </Fragment>

                            }
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            {modalSeleccionarInstalacion()}
            {modalSubirInforme()}
            {modalConfirmarDictaminar()}
            {modalAgregarObservaciones()}
        </Fragment>
    );
}

export default withRouter(SolicitudComponent)